import React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { usePublisherGameUpdates } from "@seabrookstudios/pitch2table";
import {
  AutoRejectNoticeStatus,
  getLatestUpdateTimestamp,
  shouldShowAutoRejectWarning,
} from "@seabrookstudios/pitch2table-core";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").DesignerPublisherGameView} props.publisherGame
 * @param {import("@seabrookstudios/pitch2table-core").PublisherForApp|null|undefined} props.publisher
 */
export const PublisherAutoRejectWarning = ({ publisherGame, publisher }) => {
  const { data: updates = [] } = usePublisherGameUpdates(publisherGame.id);

  if (!publisher) {
    return null;
  }

  if (!AutoRejectNoticeStatus.includes(publisherGame.status)) {
    return null;
  }

  if (updates.length === 0) {
    return null;
  }

  const dateToUse = getLatestUpdateTimestamp(updates);

  if (!shouldShowAutoRejectWarning(publisherGame.status, dateToUse, publisher.autoRejectDays)) {
    return null;
  }

  return (
    <>
      <Alert severity="error">
        This publisher has stated to consider submissions longer than {publisher.autoRejectDays} days as declined.
        Please check their submission guidelines for more information.
      </Alert>
      <Box p={1} />
    </>
  );
};
